import React from 'react';
import { Link } from 'react-router-dom';
import { appNamedRoutes } from '../routes';

const NotFound = () => (
  <div className="row u-navbar-padding">
    <div className="column u-margin-top--large">
      <Link className='o-sp-button o-sp-button--back' to={appNamedRoutes.partnerRoot}>
        <i className='sp-icon-arrow-left'></i>&nbsp;Go to Home
      </Link>
      <h1 className='u-margin-top--base'>Page Not Found</h1>
      <p>The page you are looking for does not exist or you do not have permission to view it.</p>
    </div>
  </div>
);

export default NotFound;
